import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ProjectDetail() {
  const { t } = useTranslation('common');
  const [activeImage, setActiveImage] = useState(0);

  const handleNavClick = (sectionId: string) => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Custom Navbar for Project Detail */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
        <div className="w-full px-6 md:px-12 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <a 
              href="#" 
              onClick={(e) => { 
                e.preventDefault(); 
                window.REACT_APP_NAVIGATE('/');
              }} 
              className="flex items-center cursor-pointer"
            >
              <img 
                src="https://static.readdy.ai/image/5a473773e458290c64cd1d32a10fb3f8/6ab48403ab5b8134b77f3992bcb98965.jpeg" 
                alt="Ernado Logo" 
                className="h-12 w-auto object-contain"
              />
            </a>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-10">
              <a
                href="#projects"
                onClick={(e) => { e.preventDefault(); handleNavClick('projects'); }}
                className="transition-colors cursor-pointer text-gray-700 hover:text-gray-900"
              >
                {t('nav.projects')}
              </a>
              <a
                href="#ar-experience"
                onClick={(e) => { e.preventDefault(); handleNavClick('ar-experience'); }}
                className="transition-colors cursor-pointer text-gray-700 hover:text-gray-900"
              >
                {t('nav.ar')}
              </a>
              <a
                href="#furniture"
                onClick={(e) => { e.preventDefault(); handleNavClick('furniture'); }}
                className="transition-colors cursor-pointer text-gray-700 hover:text-gray-900"
              >
                {t('nav.furniture')}
              </a>
              <a
                href="#news"
                onClick={(e) => { e.preventDefault(); handleNavClick('news'); }}
                className="transition-colors cursor-pointer text-gray-700 hover:text-gray-900"
              >
                {t('nav.news')}
              </a>
              <a
                href="#exterior"
                onClick={(e) => { e.preventDefault(); handleNavClick('exterior'); }}
                className="transition-colors cursor-pointer text-gray-700 hover:text-gray-900"
              >
                {t('nav.exterior')}
              </a>

              {/* AI Assistant Button */}
              <button
                onClick={() => {
                  const vapiButton = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
                  if (vapiButton) {
                    vapiButton.click();
                  }
                }}
                className="flex items-center space-x-2 px-4 py-2 rounded-full transition-all cursor-pointer whitespace-nowrap bg-gray-900 text-white hover:bg-gray-800"
              >
                <i className="ri-robot-2-line text-lg"></i>
                <span className="text-sm font-medium">{t('nav.aiAssistant')}</span>
              </button>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}
